import React from 'react'
import { translate } from 'react-i18next'

import Icon from '../../Global/Icon'

export default translate('common')(
  ({
    t,
    trip: {
      acf: {
        number_steps,
        text_presentation_trip_mobile,
        trip_length,
        trip_time,
      },
      slug,
      title,
    },
  }) => (
    <div className="carousel__slide" data-slug={slug}>
      <h2 className="carousel__title">{title.rendered}</h2>
      <div className="carousel__holder" />
      {(text_presentation_trip_mobile && text_presentation_trip_mobile.length > 0) && <div className="carousel__text" dangerouslySetInnerHTML={{__html: text_presentation_trip_mobile}} />}
      <ul className="carousel__items">
        {(trip_time && trip_time.length > 0) && (
          <li className="carousel__item">
            <Icon className="icon icon-clock" icon="clock" />
            <span>{trip_time}</span>
          </li>
        )}
        {(trip_length && trip_length.length > 0) && (
          <li className="carousel__item">
            <Icon className="icon icon-pin" icon="pin" />
            <span>{trip_length}</span>
          </li>
        )}
        {(number_steps && number_steps.length > 0) && (
          <li className="carousel__item">
            <span>{`${ t('home-slide.step') } : ${number_steps}`}</span>
          </li>
        )}
      </ul>
    </div>
  )
)


// WEBPACK FOOTER //
// ./src/components/Home/HomeSlide/HomeSlide.js